import { useMutation } from '@tanstack/react-query';
import LeadContractService, {
  IIssueContractParams,
} from '@clickersphere/core/services/LeadContractService';

export function usePreviewContract() {
  const {
    isPending: previewContractIsPending,
    mutateAsync: previewContractAsync,
  } = useMutation({
    mutationFn: async ({
      leadId,
      data,
    }: {
      leadId: string;
      data: IIssueContractParams;
    }) => LeadContractService.preview(leadId, data),
  });

  return {
    previewContractAsync,
    previewContractIsPending,
  };
}
